import React from "react";
import { connect } from 'react-redux';
import styled from "styled-components";
import Carousel from "react-multi-carousel";
import {CustomLeftArrow, CustomRightArrow} from "../Components/CustomArrows";
import EngrainMap from "../../Utility/EngrainMap/EngrainMap";


const UnitMapCarousel = styled(Carousel)`

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
    position: unset !important; // Override carousel default positioning
  }

`;



function UnitMap({ data }) {
  const responsive = {
      allSizes: {
      breakpoint: {max: 5000, min: 0},
      items: 1,
      }
  };
  return (
    <UnitMapCarousel
      className="UnitMapCarousel"
      responsive={responsive}
      minimumTouchDrag={0}
      // autoPlay prop doesn't seem to work so that's why the autoPlaySpeed is set to 10h
      autoPlay={false}
      autoPlaySpeed={36000000}
      arrows
      customLeftArrow={<CustomLeftArrow specialsType="unitmap"/>}
      customRightArrow={<CustomRightArrow specialsType="unitmap"/>}
    >
      {data.map((el, key) => {
        return <EngrainMap data={el} key={key}></EngrainMap>
      })}
    </UnitMapCarousel>
  );
}

export default UnitMap;
